export enum SignUpResponseType {

    ActivationEmailSent = "ACTIVATION_EMAIL_SENT",
}
